import PropTypes from "prop-types";
import React, { Component } from "react";

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import SurveySettingsPanel from "./SurveySettingsPanel";
import { FormattedMessage, injectIntl } from "react-intl";
import ModalDialogUtil from "../../../utils/ModalDialogUtil";

class SurveySettings extends Component {
  componentDidMount() {
    this.props.loadTemplateLanguages();
  }

  close() {
    this.props.closeSettings();
  }

  confirm() {
    const { submitSettings, isNew } = this.props;
    submitSettings(isNew);
  }

  render() {
    const {
      isNew,
      surveyName,
      fundingArea,
      program,
      programInstance,
      project,
      fieldErrorMessages,
      changeProperty,
      surveyLanguage,
      filterSelected,
      templateLanguages,
      surveyActivationPeriod,
      surveyIsCopy
    } = this.props;
    return (
      <Modal size="lg" show={this.props.showDialog} onExit={() => ModalDialogUtil.closeModalDialogBodyFix()}>
        <Modal.Header>
          <Modal.Title>
            <FormattedMessage
              id={
                surveyIsCopy
                  ? "user.surveyBuilder.surveySettingsPanel.copy.title"
                  : isNew
                  ? "user.surveyBuilder.surveySettingsPanel.title"
                  : "user.surveyBuilder.surveySettingsPanel.edit.title"
              }
            />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SurveySettingsPanel
            isNew={isNew}
            surveyName={surveyName}
            fundingArea={fundingArea}
            program={program}
            programInstance={programInstance}
            project={project}
            fieldErrorMessages={fieldErrorMessages}
            changeProperty={changeProperty}
            surveyLanguage={surveyLanguage}
            filterSelected={filterSelected}
            templateLanguages={templateLanguages}
            surveyActivationPeriod={surveyActivationPeriod}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.close.bind(this)}>
            <FormattedMessage id="app.common.Cancel" />
          </Button>
          <Button onClick={() => this.confirm()}>
            <FormattedMessage id={isNew ? "app.common.Create" : "app.common.Apply"} />
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

SurveySettings.propTypes = {
  showDialog: PropTypes.bool.isRequired,
  isNew: PropTypes.bool,
  surveyName: PropTypes.string,
  fundingArea: PropTypes.object,
  program: PropTypes.object,
  programIndicator: PropTypes.object,
  project: PropTypes.object,
  identifier: PropTypes.string,
  closeSettings: PropTypes.func,
  submitSettings: PropTypes.func,
  fieldErrorMessages: PropTypes.object,
  changeProperty: PropTypes.func,
  filterSelected: PropTypes.func,
  loadTemplateLanguages: PropTypes.func,
  saveSurveySettings: PropTypes.func,
  programInstance: PropTypes.object,
  surveyActivationPeriod: PropTypes.object,
  templateLanguages: PropTypes.array,
  numberOfProjectsToActivate: PropTypes.string,
  surveyLanguage: PropTypes.object,
  getNumberOfActivatedProjects: PropTypes.func,
  surveyIsCopy: PropTypes.bool
};

export default injectIntl(SurveySettings);
